import React from 'react';
import DescriptionContainer from './DescriptionContainer';

export default (props) => {
    return  <DescriptionContainer task_info_header={props.task_info_header} task_info_paragraph={props.task_info_paragraph} header={props.header} challengeImage={props.challengeImage} videoUrl={props.videoUrl} watchVideoLabel={props.watchVideoLabel} description_header={props.description_header} description_paragraph={props.description_paragraph} task_header={props.task_header} task_paragraph={props.task_paragraph} requirements_header={props.requirements_header} requirements_paragraph={props.requirements_paragraph} paragraph={props.paragraph} />
}


// WEBPACK FOOTER //
// ./src/components/description/index.jsx